import { getClerkToken } from './clerkToken'

const baseJsonHeaders = token => ({
    Accept: 'application/json',
    'Content-Type': 'application/json',
    Authorization: 'Bearer ' + (token || '')
})

export const aGet = async (auth, url) => {
    const token = await getClerkToken()
    return fetch(url, {
        method: 'get',
        headers: baseJsonHeaders(token)
    })
}

export const aGetExternalApi = (url, token) => fetch(url, {
    method: 'get',
    mode: 'no-cors',
    headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + token
    }
})

export const aPut = async (auth, url) => {
    const token = await getClerkToken()
    return fetch(url, {
        method: 'put',
        headers: baseJsonHeaders(token)
    })
}

export const aPost = async (auth, url, body, headers = null) => {
    const token = await getClerkToken()
    return fetch(url, {
        method: 'post',
        body: JSON.stringify(body),
        timeout: 300000,
        headers: {
            ...baseJsonHeaders(token),
            ...headers
        }
    })
}

export const aPostFile = async (auth, url, body) => {
    const token = await getClerkToken()
    return fetch(url, {
        method: 'post',
        body: JSON.stringify(body),
        headers: { Authorization: 'Bearer ' + token }
    })
}

export const aPatch = async (auth, url, body) => {
    const token = await getClerkToken()
    return fetch(url, {
        method: 'post',
        body: JSON.stringify(body),
        headers: baseJsonHeaders(token)
    })
}

export const aDelete = async (auth, url) => {
    const token = await getClerkToken()
    return fetch(url, {
        method: 'delete',
        headers: baseJsonHeaders(token)
    })
}
